import { Button, Divider } from 'antd';
import React, { ReactElement, useState } from 'react';
import AirportsList from './AirportsList';

function Airports({ airports }): ReactElement {
  const [showAllAirports, setShowAllAirports] = useState(false);
  return (
    <div className="container px-4 mx-auto">
      <div
        className={`shadow-sm overflow-hidden ${
          showAllAirports ? 'h-auto' : 'h-60 md:h-32'
        } rounded-md flex flex-col py-6 px-6 mt-8 mx-2 border`}
      >
        <div className="w-full grid grid-cols-1 md:grid-cols-3">
          <div className="col-span-2">
            <h2 className="text-2xl text-center md:text-left">Our Airports</h2>
            <p className="pt-2 lg:py-0 text-center md:text-left max-w-2xl">
              Book a great deal on multi-day airport parking. Compare prices,
              shuttle times and more at hundreds of facilities nationwide.
            </p>
          </div>
          <div className="flex justify-center mt-4 md:justify-end md:mt-0 items-center">
            <Button
              type="primary"
              size="large"
              className="rounded-full uppercase bg-primary"
              onClick={() => setShowAllAirports(!showAllAirports)}
            >
              {showAllAirports ? 'Hide Airports' : 'View All Airports'}
            </Button>
          </div>
        </div>

        <div
          className={`w-full pt-8 ${showAllAirports ? 'visible' : 'invisible'}`}
        >
          <Divider />
          <AirportsList airports={airports} />
        </div>
      </div>
    </div>
  );
}

export default Airports;
